// extracted by mini-css-extract-plugin
export default {"Howitworks":"Howitworks_Howitworks__uNDoY","Left":"Howitworks_Left__Lb6RC","Text":"Howitworks_Text__yPZNA"};